import React, { Component } from 'react'
import './navbar.css';
import './footer.css'
import { Link } from "gatsby";
import {Helmet} from "react-helmet";

import logo from'../../images/Souths-Logo.png';

class Navbar extends Component {
    constructor(props){
        super(props);
        this.state = {
            scrolled: false
        }
    }

    componentDidMount = () => {
        window.addEventListener('scroll', e => {
            if(window.scrollY > 0){
                this.setState({scrolled: true})
            } else {
                this.setState({scrolled: false})
            }
        });
    }
    render(){

        return (
            
            <div>
                 <Helmet>
                    <meta charSet="utf-8" />
                    <title>Souths United</title>
                </Helmet>
            <nav className={`nav ${this.state.scrolled ? 'scrolled' : ''}`}>
                <div className="nav-flex">
                <div className="nav-brand">
                    <img src={logo} alt="Souths Logo" />
                </div> 
                <div className="nav-group">
                        <Link to="/" className="nav-links">Home</Link>
                        <Link to="/about" className="nav-links">About</Link>
                        <Link to="/teams" className="nav-links">Teams</Link>
                        <Link to="/shop" className="nav-links">Shop</Link>
                        <Link to="/news" className="nav-links">News</Link>
                        <Link to="/contact" className="nav-links">Contact</Link>
                        <input type="checkbox" class="navigation__checkbox" id="navi-toggle" />
                        <label for="navi-toggle" class="navigation__button">
                            <span class="navigation__icon">&nbsp;</span>
                        </label>
                        <div class="navigation__background">&nbsp;</div>
                        <nav class="navigation__nav">
                        <ul class="navigation__list">
                            <li class="navigation__item"><Link to="/" className="navigation__link">Home</Link></li>
                            <li class="navigation__item"><Link to="/about" className="navigation__link">About</Link></li>
                            {/* <li class="navigation__item"><Link to="/" className="navigation__link">Coaching</Link></li> */}
                            <li class="navigation__item"><Link to="/teams" className="navigation__link">Teams</Link></li>
                            <li class="navigation__item"><Link to="/shop" className="navigation__link">Shop</Link></li>
                            <li class="navigation__item"><Link to="/news" className="navigation__link">News</Link></li>
                            <li class="navigation__item"><Link to="/contact" className="navigation__link">Contact</Link></li>
                            </ul>
                    </nav>
                </div>
                </div>
            </nav>
            <div className="spacer"></div>

                <div class="navigation">
                

                    
                </div>

            </div>

        )
    }
}

export default Navbar;